module.exports = __webpack_public_path__ + "static/media/proj11_img3.4b913326.jpg";